function validateBarcode(barcode: string, barcodes: string | string[]): boolean {
  if (Array.isArray(barcodes)) {
    return barcodes.includes(barcode)
  }

  return validateBarcode(barcode, barcodes.split(','))
}

export { validateBarcode };
